module.exports = __webpack_public_path__ + "media/images/new-ui-images/flag-7ef260cbe88e909cf5bab6815c80ebfc.svg";